// Prefix shared by all Missions data-testids.
export const MISSIONS_TEST_ID_PREFIX = 'crown-missions';
